var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEye(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 21,
    viewBox: "0 0 25 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.6771 7.0562C20.8858 2.66995 16.8017 0.144531 12.5 0.144531C10.3492 0.144531 8.25874 0.772865 6.34957 1.94495C4.44041 3.12911 2.72457 4.85703 1.32291 7.0562C0.114573 8.95328 0.114573 12.0345 1.32291 13.9316C4.11416 18.3299 8.19832 20.8433 12.5 20.8433C14.6508 20.8433 16.7412 20.2149 18.6504 19.0429C20.5596 17.8587 22.2754 16.1308 23.6771 13.9316C24.8854 12.0466 24.8854 8.95328 23.6771 7.0562ZM12.5 15.3816C9.79332 15.3816 7.61832 13.1945 7.61832 10.4999C7.61832 7.80536 9.79332 5.61828 12.5 5.61828C15.2067 5.61828 17.3817 7.80536 17.3817 10.4999C17.3817 13.1945 15.2067 15.3816 12.5 15.3816Z",
    fill: "#036185"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 7.04395C10.6029 7.04395 9.05624 8.59061 9.05624 10.4998C9.05624 12.3969 10.6029 13.9435 12.5 13.9435C14.3971 13.9435 15.9558 12.3969 15.9558 10.4998C15.9558 8.60269 14.3971 7.04395 12.5 7.04395Z",
    fill: "#036185"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEye);
export default __webpack_public_path__ + "static/media/eye.b4fb0ceb8a84ecff0de44d3f730b191c.svg";
export { ForwardRef as ReactComponent };